import React, { useState } from "react";
import "../styles/FinanceCar.css";
import EMICalculator from "../components/finance/EMICalculator";
import FinanceProcess from "../components/finance/FinanceProcess";
import FinancePartners from "../components/finance/FinancePartners";
import FinanceFAQ from "../components/finance/FinanceFAQ";
import LoanEligibilityModal from "../components/finance/LoanEligibilityModal";

const FinanceCar = () => {
  const [showLoanEligibility, setShowLoanEligibility] = useState(false);

  return (
    <div className="finance-car-page">
      {/* Hero Section */}
      <section className="finance-hero">
        <div className="hero-content">
          <div className="hero-icon">
            <svg width="80" height="80" viewBox="0 0 80 80">
              <rect width="80" height="80" rx="20" fill="#87CEEB" opacity="0.6" />
              <path d="M40 20L25 32V52H55V32L40 20Z" fill="#FF6B6B" />
              <circle cx="40" cy="42" r="8" fill="#FAFAFA" />
            </svg>
          </div>

          <h1>Loan</h1>
          <h2>Financing made possible for every car</h2>

          <div className="hero-features">
            <div className="feature-item">✅ Completely Online</div>
            <div className="feature-item">⚡ Same-day Approval</div>
          </div>

          {/* ✅ ONLY ENTRY POINT */}
          <button
            className="secondary-cta"
            onClick={() => setShowLoanEligibility(true)}
          >
            💰 Check Loan Eligibility
          </button>

          <p className="reassurance-text">
            Don’t worry! This won’t affect your credit score
          </p>
        </div>
      </section>

      {/* EMI Calculator */}
      <EMICalculator />

      {/* Smart Way */}
      <section className="smart-way-section">
        <h2>The smart way to loan</h2>
        <p>
          Zero down payment. Best interest rates. Lowest processing fee.
        </p>
      </section>

      <FinanceProcess />
      <FinancePartners />
      <FinanceFAQ />

      {/* ✅ SINGLE MODAL */}
      <LoanEligibilityModal
        isOpen={showLoanEligibility}
        onClose={() => setShowLoanEligibility(false)}
        car={null}
      />
    </div>
  );
};

export default FinanceCar;
